import { Card, Button, Collapse, Dropdown } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
const NotesSection = () => {
  const [open, setOpen] = useState(true);

  const [notes, setNotes] = useState([
    {
      id: 1,
      date: "15 May 2025",
      title: "Changes & design",
      desc: "An office management app project streamlines administrative tasks by integrating tools for scheduling, communication, and task management, enhancing overall productivity and efficiency.",
    },
    {
      id: 2,
      date: "15 May 2025",
      title: "Changes & design",
      desc: "An office management app project streamlines administrative tasks by integrating tools for scheduling, communication, and task management, enhancing overall productivity and efficiency.",
    },
  ]);

  // DELETE
  const handleDelete = (id) => {
    setNotes(notes.filter((n) => n.id !== id));
  };

  return (
    <Card className="custom-card mb-3">
      <Card.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6>Notes</h6>

          <div className="d-flex align-items-center gap-2">
            <Button className="btn-orange btn-sm">
              <FiPlus /> Add New
            </Button>

            <span
              className="accordion-icon"
              onClick={() => setOpen(!open)}
            >
              {open ? "⌃" : "<MdKeyboardArrowDown/>"}
            </span>
          </div>
        </div>

        {/* ACCORDION */}
        <Collapse in={open}>
          <div>
            {notes.map((note) => (
              <div className="note-card" key={note.id}>

                {/* TOP */}
                <div className="d-flex justify-content-between">
                  <span className="date">{note.date}</span>

                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      className="border-0"
                    >
                      <BsThreeDotsVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="note-dropdown">
                      <Dropdown.Item>
                        ✏️ Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(note.id)}>
                        🗑 Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* TITLE */}
                <div className="note-title">
                  <span className="dot"></span>
                  {note.title}
                </div>

                {/* DESC */}
                <p className="note-desc">{note.desc}</p>

              </div>
            ))}
          </div>
        </Collapse>

      </Card.Body>
<style>
  {
    `
    .custom-card {
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
}

/* Button */
.btn-orange {
  background: #ff6b2c;
  border: none;
}

/* Accordion icon */
.accordion-icon {
  cursor: pointer;
  font-size: 18px;
  color: #555;
}

/* NOTE CARD */
.note-card {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  background: #fff;
  transition: 0.2s;
}

/* Date */
.date {
  font-size: 13px;
  color: #777;
}

/* Title */
.note-title {
  margin-top: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Orange dot */
.note-title .dot {
  width: 6px;
  height: 6px;
  background: #ff6b2c;
  border-radius: 50%;
}

/* Description */
.note-desc {
  font-size: 13px;
  color: #6c757d;
  margin-top: 5px;
}

/* Dropdown */
.note-dropdown {
  border-radius: 10px;
  padding: 10px;
  min-width: 140px;
}

/* Mobile */
@media (max-width: 768px) {
  .note-card {
    padding: 12px;
  }
}`
  }
</style>
    </Card>
  );
};

export default NotesSection;